import React from 'react';
import { Database, Brain, Target, ArrowRight } from 'lucide-react';

const HowItWorks: React.FC = () => {
  const steps = [
    {
      icon: Database,
      title: "Data Ingestion",
      description: "Pull data from ERP Systems, GPO Contracts, Distributors, and clinical communications",
      color: "bg-primary-100 text-primary-600"
    },
    {
      icon: Brain,
      title: "Matching Logic",
      description: "Use AI to automatically match substitute products with items that are in shortage",
      color: "bg-secondary-100 text-secondary-600"
    },
    {
      icon: Target,
      title: "Recommendation Engine",
      description: "Output clinically vetted, compliant alternatives that align with operational, financial, and clinician preferences",
      color: "bg-primary-100 text-primary-600"
    }
  ];

  return (
    <section id="how-it-works" className="py-16 sm:py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12 mb-12 sm:mb-16">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative"
            >
              {/* Step Card */}
              <div className="card p-6 sm:p-8 h-full">
                {/* Step Number */}
                <div className="absolute -top-3 -left-3 sm:-top-4 sm:-left-4 w-10 h-10 sm:w-12 sm:h-12 bg-primary-400 text-white rounded-full flex items-center justify-center font-bold text-base sm:text-lg">
                  {index + 1}
                </div>

                {/* Icon */}
                <div className={`w-12 h-12 sm:w-16 sm:h-16 ${step.color} rounded-2xl flex items-center justify-center mb-4 sm:mb-6`}>
                  <step.icon size={24} className="sm:w-8 sm:h-8" />
                </div>

                {/* Content */}
                <h3 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-3 sm:mb-4">
                  {step.title}
                </h3>
                <p className="text-sm sm:text-base text-neutral-600 leading-relaxed">
                  {step.description}
                </p>
              </div>

              {/* Arrow (except for last step) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-6 transform -translate-y-1/2 z-10">
                  <div className="w-12 h-12 bg-primary-400 rounded-full flex items-center justify-center">
                    <ArrowRight size={24} className="text-white" />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Key Message */}
        <div className="text-center">
          <div className="bg-gradient-to-r from-primary-50 to-secondary-50 rounded-3xl p-8 sm:p-12 lg:p-16">
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-neutral-900 mb-4 sm:mb-6">
              AI + Human Clinical Context = Smarter Substitution Decisions
            </h3>
            <p className="text-lg sm:text-xl text-neutral-600 max-w-2xl mx-auto">
              Our platform combines artificial intelligence with deep clinical expertise to deliver the most relevant and safe alternatives for your healthcare system.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export { HowItWorks }; 